import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { RectangularTextButton } from "components/Base/Buttons";

interface DeleteConfirmDialogProps {
  open: boolean;
  warningMessage?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  warningMessage = "Are you sure you want to delete this node? This action cannot be undone.",
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Confirm Delete</DialogTitle>

      <DialogContent>
        <Typography>{warningMessage}</Typography>
      </DialogContent>

      <DialogActions>
        <RectangularTextButton colour="clear" onClick={onCancel}>
          Cancel
        </RectangularTextButton>

        <RectangularTextButton
          colour="highlighted"
          onClick={onConfirm}
          primaryColor="#d32f2f"
          textColor="#fff"
        >
          Delete
        </RectangularTextButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;